<template>
  <c-layout :spinning="page.loading">
    <a-row class="table-title">
      <!--      <a-col :span="4">-->
      <!--        <a-button @click="addPublish()">上传公示表格文件</a-button>-->
      <!--      </a-col>-->
      <!--      <a-col :span="4" :offset="3">-->
      <!--        <a-input placeholder="输入名称关键字" allow-clear class="search-input" v-model="tables.search.name"/>-->
      <!--      </a-col>-->
      <!--      <a-col :span="4" :offset="1">-->
      <!--        <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间','结束时间']" v-model="tables.search.time">-->
      <!--          <a-icon slot="suffixIcon" type="close-circle"/>-->
      <!--        </a-range-picker>-->
      <!--      </a-col>-->
      <a-col :span="2" style="text-align: right">
        年度：
      </a-col>
      <a-col :span="4">
        <a-select v-model="tables.search.year" style="width: 100%" placeholder="公示年度" allowClear size="small">
          <a-select-option v-for="item in options.years" :value="item.value">{{ item.label }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4" :offset="1">
        <a-button icon="search" type="primary" @click="startSearch">搜索</a-button>
      </a-col>
    </a-row>
    <a-divider/>
    <a-modal :visible="show.addPublish" width="30%" @cancel="closePublishForm">
      <a-form-model :model="form.publish" :rules="form.rules.publish" ref="publishForm" :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-form-model-item label="类型">
          <a-radio-group v-model="form.publish.dataType" @change="changeDataType">
            <a-radio :value="item.value" v-for="item in options.types">
              <span>{{ item.label }}</span>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="公示年度" prop="year">
          <a-select v-model="form.publish.year" style="width: 70%">
            <a-select-option v-for="item in options.years" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="发布时间" prop="publishTime">
          <a-date-picker :locale="locale" v-model="form.publish.publishTime"/>
        </a-form-model-item>
        <a-form-model-item label="说明文件" v-if="!options.isEdit && (form.publish.dataType<4||form.publish.dataType==6)">
          
           <a-col :span="8" v-if="!(form.publish.dataType==2||form.publish.dataType==3)">
            <a-upload name="file" :multiple="false" :action="uploadConf.url" 
            	:before-upload="file=>beforeUpload(file,'.pdf')" accept=".pdf" :custom-request="customRequest" 
            	:headers="uploadConf.headers" @change="uploadWordFile" :file-list="form.wordList">
              <a-button>
                <a-icon type="upload"/>
                点击上传
              </a-button>
            </a-upload>
          </a-col>
          <a-col :span="16" v-if="!(form.publish.dataType==2||form.publish.dataType==3)">
            <span>文件格式要求：pdf</span>
          </a-col>
          
          <a-col :span="12" v-if="form.publish.dataType==2||form.publish.dataType==3">
            <a-upload name="file" :multiple="false" :action="uploadConf.url" 
            	:before-upload="file=>beforeUpload(file,'.pdf')" accept=".pdf" :custom-request="customRequest" 
            	:headers="uploadConf.headers" @change="uploadWordFile" :file-list="form.wordList">
				
            	<a-button>
            		<a-icon type="upload"/>点击上传文件一
            	</a-button>
            </a-upload>
          </a-col>
          <a-col :span="12" v-if="form.publish.dataType==2||form.publish.dataType==3">
            <span>文件格式要求：pdf</span>
          </a-col>
          <a-col :span="12" style="clear: both;" v-if="form.publish.dataType==2||form.publish.dataType==3">
            <a-upload name="file" :multiple="false" :action="uploadConf.url" 
            	:before-upload="file=>beforeUpload(file,'.pdf')" accept=".pdf" :custom-request="customRequest" 
            	:headers="uploadConf.headers" @change="info=>uploadWordFile(info,'1')" :file-list="form.wordList2">
             	
            	<a-button>
            		<a-icon type="upload"/> 点击上传文件二
            	</a-button>
            </a-upload>
          </a-col>
          <a-col :span="12" v-if="form.publish.dataType==2||form.publish.dataType==3">
            <span>文件格式要求：pdf</span>
          </a-col>
        </a-form-model-item>
        <a-form-model-item label="公示文件" v-if="!options.isEdit">
          <a-col :span="8">
            <a-upload name="file" :multiple="false" :action="uploadConf.url" 
            	:before-upload="file=>beforeUpload(file,'.xlsx')" accept=".xlsx"
            	:headers="uploadConf.headers" @change="uploadExcelFile"
            	:custom-request="customRequest" :file-list="form.excelList">
              <a-button>
                <a-icon type="upload"/>
                点击上传
              </a-button>
            </a-upload>
          </a-col>
          <a-col :span="16">
            <span>文件格式要求：xlsx</span>
          </a-col>
        </a-form-model-item>
        
        <p v-if="show.fileList">请勾选需要显示的文件</p>
        <a-spin :spinning="page.loadingSplit" tip="解析数据中，解析时间视sheet数量而定，请耐心等候......">
          <a-skeleton active v-if="page.loadingSplit"/>
          <a-list size="small" bordered :data-source="options.fileList" class="file-list" v-if="show.fileList">
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-col :span="1">
                <a-checkbox v-model="options.checkBoxList[index]"></a-checkbox>
              </a-col>
              <a-col :span="19">
                <a-input v-model="options.fileList[index].customName" size="small"
                         v-show="!!options.isEditList[index]"/>
                <span v-show="!options.isEditList[index]">{{ options.fileList[index].customName }}</span>
              </a-col>
              <a-col :span="3">
                <a-button type="primary" size="small" @click="saveList(index)" v-if="!!options.isEditList[index]">保&nbsp;&nbsp;存
                </a-button>
                <a-button size="small" @click="editList(index)" v-else>重命名</a-button>
              </a-col>
            </a-list-item>
          </a-list>
        </a-spin>
      </a-form-model>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closePublishForm">关闭</a-button>
        <a-button type="primary" @click="submitPublishForm" :disabled="options.fileList.length === 0">发布</a-button>
      </div>
    </a-modal>
    <a-modal :visible="show.fileListModal" width="50%">
      <p v-if="">请勾选需要显示的文件</p>
      <a-spin :spinning="page.loadingSplit" tip="解析数据中，解析时间视sheet数量而定，请耐心等候......">
	      <a-skeleton active v-if="page.loadingSplit"/>
	      <a-list size="small" bordered :data-source="options.fileList" class="file-list">
	        <a-list-item slot="renderItem" slot-scope="item, index">
	          <a-col :span="1">
	            <a-checkbox v-model="options.checkBoxList[index]"></a-checkbox>
	          </a-col>
	          <a-col :span="19">
	            <a-input v-model="options.fileList[index].customName" size="small" v-show="!!options.isEditList[index]"/>
	            <span v-show="!options.isEditList[index]">{{ options.fileList[index].customName }}</span>
	          </a-col>
	          <a-col :span="3">
	            <a-button type="primary" size="small" @click="saveList(index)" v-if="!!options.isEditList[index]">保&nbsp;&nbsp;存
	            </a-button>
	            <a-button size="small" @click="editList(index)" v-else>重命名</a-button>
	          </a-col>
	        </a-list-item>
	      </a-list>
      </a-spin>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeExcelForm">关闭</a-button>
        <a-button type="primary" @click="updateExcelSave" :disabled="options.fileList.length === 0">保存</a-button>
      </div>
    </a-modal>
    <a-modal :visible="show.wordFileModal" width="50%" @cancel="closeWordFileForm">
      <p v-if="">请选择需要替换的说明文件</p>
      <a-radio-group v-model='form.updateWordValue' name="updateWordNum">
      	 <a-radio value="1" v-if="form.updateWordPublish.wordFile&&form.updateWordPublish.wordFile.uploadName">
      	 	{{form.updateWordPublish.wordFile.uploadName}}
  	 	 </a-radio>
  	 	 <a-radio value="1" v-if="!(form.updateWordPublish.wordFile&&form.updateWordPublish.wordFile.uploadName)">
      	 	说明文件一
  	 	 </a-radio>
  	 	 <a-radio value="2" v-if="form.updateWordPublish.wordFile2&&form.updateWordPublish.wordFile2.uploadName">
      	 	{{form.updateWordPublish.wordFile2.uploadName}}
  	 	 </a-radio>
  	 	 <a-radio value="2" v-if="!(form.updateWordPublish.wordFile2&&form.updateWordPublish.wordFile2.uploadName)">
      	 	说明文件二
  	 	 </a-radio>
      </a-radio-group>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeWordFileForm">关闭</a-button>
        <a-button type="primary" @click="updateWordPublishSave">保存</a-button>
      </div>
    </a-modal>
    <a-tabs type="card" @change="changeTab" v-model="tables.search.dataType">
      <a-button slot="tabBarExtraContent" @click="addPublish()" type="primary">上传公示文件</a-button>
      <a-tab-pane :key="item.key" :tab="item.name" v-for="item in options.tabs" :value="item.key">
        <a-table :data-source="tables.dataSource.publish" :columns="tables.columns"
                 :pagination="true" rowKey="id">
          <template slot="action" slot-scope="text, record">
            <c-pop-button title="确定要删除吗" text="删除" type="danger" @click="removePublish(record)"/>
            <a-divider type="vertical" v-show="false"/>
            <a-button type="primary" size="small" @click="editPublish(record)" v-show="false">编辑</a-button>
            <a-divider type="vertical"/>
            <template v-if="record.dataType<4 || record.dataType==6">
              <a-upload name="file" :multiple="false" :action="uploadConf.url" :headers="uploadConf.headers"
                        accept=".pdf" :before-upload="file=>beforeUpload(file,'.pdf')" :custom-request="customRequest" 
                        @change="value=>changeWordFile(value,record)" :showUploadList="false">
                <a-button size="small">修改说明文件</a-button>
              </a-upload>
              <a-divider type="vertical"/>
            </template>
			<a-upload name="file" :multiple="false" :action="uploadConf.url" :headers="uploadConf.headers"
				accept=".xlsx" :before-upload="file=>beforeUpload(file,'.xlsx')" :custom-request="customRequest" 
				@change="value=>changeExcelFile(value,record)" :showUploadList="false">
				<a-button size="small">修改公示文件</a-button>
			</a-upload>
          </template>
          <template slot="name" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <template slot="status" slot-scope="text, record">
            <span style="display: none">{{ text }}</span>
            <a-tag color="blue" v-if="text===0">待审核</a-tag>
            <a-tag color="green" v-if="text===1">审核通过</a-tag>
            <a-tag color="red" v-if="text===2">已驳回</a-tag>
          </template>
          <template slot="wordFile" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.wordFile.uploadName" v-if="record.wordFile">
              <p @click="viewPDF(record,'0')"> {{ record.wordFile.uploadName }}</p>
            </a-tooltip>
            <a-tooltip placement="topLeft" :title="record.wordFile2.uploadName" v-if="record.wordFile2">
              <p @click="viewPDF(record,'1')"> {{ record.wordFile2.uploadName }}</p>
            </a-tooltip>
          </template>
          <template slot="excelFile" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.excelFile.uploadName" @click="downloadExcelFile(record)">
              {{ record.excelFile.uploadName }}
            </a-tooltip>
          </template>
          <template slot="excelFileList" slot-scope="text, record">
            <a-popover>
              <template slot="content" v-for="item in record.excelFileList">
                <p @click="viewFile(item)">{{ item.customName }}</p>
              </template>
              <a-button size="small">显示列表</a-button>
            </a-popover>
          </template>
          <template slot="unacceptContent" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="text" v-if="text">
              {{ text }}
            </a-tooltip>
            <span v-else>-</span>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal :visible="show.viewExcel" width="75%" @cancel="closeExcelView" :closable="false">
      <div class="excel-parent">
        <div id="excelView1" :style="excelView.spreadStyle"></div>
      </div>
      <div class="drawer-bottom-button">
        <a-button :style="{ marginRight: '8px' }" @click="closeExcelView">关闭</a-button>
      </div>
    </a-modal>
  </c-layout>
</template>

<script>
import CPopButton from "@comp/c-pop-button";
import {initCPagination} from "@/views/component/C-Pagination";
import {CustomApis as api} from "@/api/CustomApis";
import CTableSearch from "@/components/c-table-search"
import {SysApis} from "@/api/SysApis";
import commonApi from "@/api/CommonApi";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import {getYears,defaultYear} from "@/utils/years.js";

const pdfjsLib = require("pdfjs-dist/legacy/build/pdf.js");

export default {
  name: "publish-list",
  components: {
    CTableSearch,
    CPopButton,
  },
  watch: {
    isZsq: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.options.tabs = this.options.tabsOptions['zsq']
          this.options.types = this.options.typesOptions['zsq']
        } else {
          this.options.tabs = this.options.tabsOptions['default']
          this.options.types = this.options.typesOptions['default']
        }
      }
    }
  },
  data() {
    return {
      locale,
      excelView: {
        spreadStyle: {
          width: '100%',
          height: '100%'
        },
        spread: null,
        excelIo: null,
        init: false,
      },
      uploadConf: {
        headers: {
          'crabapples-token': sessionStorage.getItem('token'),
        },
        url: '',
      },
      page: {
        loading: false,
        loadingSplit: false,
      },
      labelCol: {span: 5},
      wrapperCol: {span: 16},
      tables: {
        columns: [],
        dataSource: {
          publish: [],
        },
        search: {
          regionId: '',
          year: '',
          dataType: '0',
        },
      },
      form: {
        rules: {
          publish: {
            type: [
              {required: true, message: '类型不能为空', trigger: 'change'},
            ],
            name: [
              {required: true, message: '请输入名称', trigger: 'change'},
              {min: 2, max: 16, message: '长度为2-16个字符', trigger: 'change'},
              {whitespace: true, message: '请输入名称', trigger: 'change'}
            ],
            publishTime: [
              {required: true, message: '请选择时间', trigger: 'change'},
            ],
            year: [
              {required: true, message: '年度不能为空', trigger: 'change'},
            ],
            wordFileName: [
              {required: true, message: '请上传说明文件', trigger: 'change'},
              {whitespace: true, message: '请上传说明文件', trigger: 'change'}
            ],
            excelFileName: [
              {required: true, message: '请上传公示文件', trigger: 'change'},
              {whitespace: true, message: '请上传公示文件', trigger: 'change'}
            ],
          },
        },
        publish: {
          dataType: '',
          name: '',
          year: '',
          wordFile: '',
          wordFile2: '',
          excelFile: '',
          wordFileName: '',
          wordFile2Name: '',
          excelFileName: '',
          excelFileList: [],
          publishTime: '',
        },
        pagination: initCPagination(this.changeIndex, this.changeSize),
        wordList: [],
        wordList2: [],
        excelList: [],
        upload: {
          name: ''
        },
        updateWordPublish: {},
        updateWordFile: null,
        updateWordValue: '1',//默认修改第一个说明文件
      },
      show: {
        addPublish: false,
        fileListButton: false,
        fileList: false,
        fileListModal: false,
        viewExcel: false,
        wordFileModal: false,
      },
      expanded: [],
      options: {
        columns: {
          publish: [
            {
              dataIndex: 'wordFile',
              title: '公示说明',
              width: '15%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'wordFile'
              }
            },
            {
              dataIndex: 'excelFile',
              title: `预算公示文件`,
              width: '15%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFile'
              }
            },
            {
              dataIndex: 'excelFileList',
              title: '公示文件列表',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFileList'
              }
            },
            {
              dataIndex: 'status',
              title: '状态',
              width: '10%',
              scopedSlots: {
                customRender: 'status'
              }
            },
            {
              dataIndex: 'year',
              title: '年度',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'year'
              }
            },
            {
              dataIndex: 'publishTime',
              title: '发布时间',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'publishTime'
              }
            },
            {
              dataIndex: 'unacceptContent',
              title: '拒绝理由',
              width: '15%',
              scopedSlots: {
                customRender: 'unacceptContent'
              }
            },
            {
              dataIndex: 'action',
              title: '操作',
              scopedSlots: {customRender: 'action'},
              width: '35%'
            },
          ],
          publishZsq: [
          	{
              dataIndex: 'excelFile',
              title: `预算公示文件`,
              width: '15%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFile'
              }
            },
            {
              dataIndex: 'excelFileList',
              title: '公示文件列表',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'excelFileList'
              }
            },
            {
              dataIndex: 'status',
              title: '状态',
              width: '10%',
              scopedSlots: {
                customRender: 'status'
              }
            },
            {
              dataIndex: 'year',
              title: '年度',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'year'
              }
            },
            {
              dataIndex: 'publishTime',
              title: '发布时间',
              width: '20%',
              ellipsis: true,
              scopedSlots: {
                customRender: 'publishTime'
              }
            },
            {
              dataIndex: 'unacceptContent',
              title: '拒绝理由',
              width: '15%',
              scopedSlots: {
                customRender: 'unacceptContent'
              }
            },
            {
              dataIndex: 'action',
              title: '操作',
              scopedSlots: {customRender: 'action'},
              width: '35%'
            },
          ],
        },
        tabs: [],
        tabsOptions: {
          default: [
            {key: '0', name: '预算公示'},
            {key: '1', name: '决算公示'},
            {key: '2', name: '预算绩效目标'},
            {key: '3', name: '决算绩效评价'},
          ],
          zsq: [{key: '0', name: '预算公示'},
            {key: '1', name: '决算公示'},
            {key: '2', name: '预算绩效目标'},
            {key: '3', name: '决算绩效评价'},
            //{key: '4', name: '批复文件'},
            //{key: '5', name: '政府债务公开'},
            {key: '6', name:'预算调整'},
          ],
        },
        types: [],
        typesOptions: {
          default: [
            {value: 0, label: '预算'},
            {value: 1, label: '决算'},
            {value: 2, label: '预算绩效目标'},
            {value: 3, label: '决算绩效评价'},
          ],
          zsq: [
            {value: 0, label: '预算'},
            {value: 1, label: '决算'},
            {value: 2, label: '预算绩效目标'},
            {value: 3, label: '决算绩效评价'},
            //{value: 4, label: '批复文件'},
            //{value: 5, label: '政府债务公开'},
            {value: 6, label: '预算调整'},
          ],
        },
        years: getYears(),
        fileList: [],
        checkBoxList: [],
        isEditList: [],
        isEdit: false,
      },
      userInfo: {},
      isZsq: null,
    }
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      this.isZsq = false
      this.tables.dataSource.publish = []
      this.getUserInfo().then(e => {
        if (e.status) {
          this.tables.search.regionId = e.data.regionId
          this.userInfo = e.data
          this.$message.success(this.userInfo.role)
          //if (this.userInfo.role === '钟山区') {
          //  this.isZsq = true
          //}
          if (this.userInfo.regionName === '钟山区'||this.userInfo.regionId === 10001) {
		    this.isZsq = true
		  }
		  	this.tables.columns = this.options.columns.publish;
        	if (this.tables.search.dataType >= 4 && this.tables.search.dataType < 6) {
          		this.tables.columns = this.options.columns.publishZsq;
        	}
          this.getList()
        }
      })
    },
    changeDataType(e) {
      this.resetPublishForm()
      this.form.publish.dataType = e.target.value
    },
    getUserInfo() {
      return commonApi.getUserInfo().then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          return Promise.resolve({status: true, data: result.data})
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
      })
    },
    closeExcelView() {
      	this.show.viewExcel = false;
    },
    downloadExcelFile(e){
    	const downLoadFileApi = `${SysApis.downLoadFile}?fileId=`+e.excelFile.id+`&r=`+Math.random();
    	this.$http.get(downLoadFileApi, {'responseType': 'blob'}).then(result => {
    		let blob = new Blob([result]);
    		let dom = document.createElement('a')
	        let url = window.URL.createObjectURL(blob)
	        dom.href = url
	        dom.download = decodeURI(e.excelFile.uploadName);
	        dom.style.display = 'none'
	        document.body.appendChild(dom)
	        dom.click()
	        dom.parentNode.removeChild(dom)
	        window.URL.revokeObjectURL(url)
		}).catch(function (error) {
	        console.error('出现错误:', error);
		});
    },
    async viewPDF(e,type) {
      if(type=='1'){
      	window.open(`/pdfjs/web/viewer.html?file=${encodeURIComponent(e.wordFile2.path)}&r=`+Math.random());
      }else{
	      window.open(`/pdfjs/web/viewer.html?file=${encodeURIComponent(e.wordFile.path)}&r=`+Math.random());
      }
    },
    viewFile(e) {
      const _this = this
      _this.show.viewExcel = true
      _this.$nextTick(() => {
        _this.page.loading = true;
        let excelView = document.querySelector('#excelView1')
        // 在mounted中声明 spread 和excelIo ，避免了改变某个参数后再次请求数据渲染界面的问题，若在 openExcel方法中声明会在该excel下方再生成一个excel
        if (!_this.excelView.init) {
          _this.excelView.spread = new GC.Spread.Sheets.Workbook(excelView);
          _this.excelView.excelIo = new GC.Spread.Excel.IO();
          _this.excelView.init = true
        }
        _this.openExcel(e.path)
        _this.page.loading = false;
      })
    },
    openExcel(path) {
      const _this = this
      this.$http.get(path, {responseType: 'blob'}).then(response => {
        let blob = new Blob([response])
        _this.excelView.excelIo.open(blob, function (json) {
          _this.excelView.spread.fromJSON(json);
          _this.excelView.spread.options.tabNavigationVisible = false;
          _this.excelView.spread.options.tabEditable = false;
          _this.excelView.spread.options.allowSheetReorder = false;
          _this.excelView.spread.options.newTabVisible = false;
          _this.excelView.spread.getActiveSheet().options.isProtected = true;//设置Excel单元格保护，禁止在线编辑
        }, function (e) {
          _this.$message.error(e.errorMessage);
        }, {});
      })
    },

    startSearch() {
      this.tables.dataSource.publish = []
      this.startLoadPage();
      this.$http.post(`${api.searchRegionPublish}`, this.tables.search).then(result => {
        if (result.status !== 200) {
          this.endLoadPage();
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          this.tables.dataSource.publish = result.data
        }
        this.endLoadPage();
      }).catch(function (error) {
        console.error('出现错误:', error);
        this.endLoadPage();
      });
    },
    startLoadPage() {
      this.page.loading = true
    },
    endLoadPage() {
      this.page.loading = false
    },
    setRow(e) {
      this.form.publish = e
    },
    addPublish() {
      this.show.addPublish = true
      this.options.isEdit = false
    },
    beforeUpload(file, type) {
      if(!file||file.size<=0){
      	this.$message.error("请选择需要上传的文件");
      	return false;
      }else if(!file.name.endsWith(type)){
		this.$message.error("请选择正确类型("+type+")的文件");
      	return false;
      }else if(file.size>10*1024*1024){
      	this.$message.error("文件大小不能超过10MB");
      	return false;
      }
      this.uploadConf.url = `${SysApis.uploadFile}?r=`+Math.random();
      return true
    },
    async customRequest(option){
    	let formData = new FormData();
    	formData.append(option.filename || 'file', option.file);
    	this.$http.post(option.action,formData,{
    		headers: {'Content-Type': 'multipart/form-data'},
    		onUploadProgress: (event)=>{
    			let percent = 0;
    			if(event.total>0){
    				percent = (event.loaded/event.total)*100;
    			}
	    		option.onProgress(parseInt(percent, 10), event);
    		}
    	}).then(response=>{
    		if(response.status!=200){
	    		this.$message.error({duration: 10,content: `${file.name} 上传失败`});
	    		return false;
	    	}
    		option.onSuccess(response, option.file);
    	}).catch(error=>{
    	});
    },
    uploadWordFile(info,type) {
      if(type=='1'){
    	this.form.wordList2 = info.fileList.slice(-1)
      	this.form.publish.wordFile2 = ''
      }else{
	 	this.form.wordList = info.fileList.slice(-1)
    	this.form.publish.wordFile = ''
      }
      
      if (info.file.status === 'done') {
        if (info.file.response.status === 200) {
          this.$message.success(`${info.file.name} 上传成功`);
          if(type=='1'){
          	  this.form.publish.wordFile2Name = info.file.response.data.path
	          this.form.publish.wordFile2 = info.file.response.data
          }else{
	          this.form.publish.wordFileName = info.file.response.data.path
	          this.form.publish.wordFile = info.file.response.data
          }
        }
      } else if (info.file.status === 'error') {
        this.$message.error({duration: 10,content: `${info.file.name} 上传失败`});
      }
    },
    changeWordFile(info,publish) {
      if (info.file.status === 'done') {
        if (info.file.response.status === 200) {
    		if (this.tables.search.dataType ==2 || this.tables.search.dataType==3) {
	        	this.$message.success({duration: 10,content: `${info.file.name} 上传成功，请选择需替换的说明文件`});
				this.form.updateWordPublish = publish;
		      	this.form.updateWordFile = info.file.response.data;
		      	this.show.wordFileModal = true;
			}else{			
	    		this.$message.success(`${info.file.name} 上传成功`);
	        	publish.wordFile = info.file.response.data
	        	this.updateWordSave(publish);
			}
        }
      } else if (info.file.status === 'error') {
        this.$message.error({duration: 10,content: `${info.file.name} 上传失败`});
      }
    },
    async uploadExcelFile(info) {
      let fileList = new Array();
      for(let i in info.fileList){
      	let infoFile = info.fileList[i];
      	if(info.file.uid==infoFile.uid){
      		fileList.push(infoFile);
      		break;
      	}
      }
      this.form.excelList = fileList;
      this.form.publish.excelFile = '';
      if (info.file.status === 'done') {
        if (info.file.response.status === 200) {
          this.$message.success({
          	duration: 7,
          	content: `${info.file.name}`+' 上传成功，请耐心等待Excel文件拆分，拆分成功（公示文件下方显示可勾选的文件）后方可提交'
      	  });
          this.form.publish.excelFileName = info.file.response.data.path
          this.form.publish.excelFile = info.file.response.data
          let res = await this.splitFile(this.form.publish.excelFile)
          if(res){          	
	          this.options.fileList = res
	          this.options.isEditList = []
	          this.options.checkBoxList = [this.options.fileList.length]
	          for (let i = 0; i < this.options.fileList.length; i++) {
	            this.options.checkBoxList[i] = true
	          }
	          this.show.fileList = true
          }
        }
      } else if (info.file.status === 'error') {
        this.$message.error({duration: 10,content: `${info.file.name} 上传失败`});
      } else {
      }
    },
    async changeExcelFile(info,publish) {
      if (info.file.status === 'done') {
        if (info.file.response.status === 200) {
          this.$message.success({
          	duration: 7,
          	content: `${info.file.name}`+' 上传成功，请耐心等待Excel文件拆分'
      	  });
          this.form.publish = publish;
          this.form.publish.excelFile = info.file.response.data
          this.show.fileListModal = true;
          let res = await this.splitFile(this.form.publish.excelFile)
          if(res){
	          this.options.fileList = res
	          this.options.isEditList = []
	          this.options.checkBoxList = [this.options.fileList.length]
	          for (let i = 0; i < this.options.fileList.length; i++) {
	            this.options.checkBoxList[i] = true
	          }
          }
        }
      } else if (info.file.status === 'error') {
        this.$message.error({duration: 10,content: `${info.file.name} 上传失败`});
      }
    },

    getList() {
      this.tables.dataSource.publish = []
      this.startLoadPage();
      this.$http.post(`${api.searchRegionPublish}`, this.tables.search).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          this.endLoadPage();
          return;
        }
        if (result.data !== null) {
          this.tables.dataSource.publish = result.data
        }
        this.endLoadPage();
      }).catch(function (error) {
        console.error('出现错误:', error);
        this.endLoadPage();
      });
    },
    splitFile(file) {
      this.page.loadingSplit = true
      this.show.fileList = false
      const splitFileApi = api.splitFile+'?r='+Math.random();
      return this.$http.get(splitFileApi, {params: {file: file.path}}).then(result => {
        if (result.status !== 200) {
          let errorMsg = 'Excel拆分失败';
          if(result.message){
          	errorMsg = result.message
          }
          this.$message.destroy();
          this.$message.error({duration: 10,content: errorMsg});
          this.page.loadingSplit = false
          return;
        }
        this.page.loadingSplit = false
        return Promise.resolve(result.data)
      }).catch(function (error) {
      	this.$message.destroy();
      	this.$message.error({duration: 10,content: 'Excel拆分异常'});
        console.error('出现错误:', error);
      });
      return;
    },
    editList(index) {
      this.$set(this.options.isEditList, index, true)
    },
    saveList(index) {
      this.$set(this.options.isEditList, index, false)
      this.renameFile(this.options.fileList[index])
    },
    renameFile(file, index) {
      let renameFileApi = SysApis.renameFile+'?r='+Math.random();
      this.$http.post(renameFileApi, file).then(result => {
        if (result.status !== 200) {
          let errorMsg = 'Excel重命名失败';
          if(result.message){
          	errorMsg = result.message
          }
          this.$message.error({
          	duration: 10,
          	content: errorMsg
          });
          return
        }
        this.$set(this.options.fileList, index, result.data)
        this.$message.success(result.message);
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    updateWordSave(publish) {
      this.$http.post(api.savePublish, publish).then(result => {
        if (result.status !== 200) {
          let errorMsg = '说明文件修改失败';
          if(result.message){
          	errorMsg = result.message
          }
          this.$message.error({
          	duration: 10,
          	content: errorMsg
          });
          return;
        }
        this.refreshData()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    updateExcelSave() {
      let fileList = []
      this.options.checkBoxList.forEach((checked, index) => {
        if (!!checked) {
          fileList.push(this.options.fileList[index])
        }
      });
      this.form.publish.excelFileList = fileList
      this.$http.post(api.savePublish, this.form.publish).then(result => {
        if (result.status !== 200) {
          let errorMsg = '公示文件修改失败';
          if(result.message){
          	errorMsg = result.message
          }
          this.$message.error({
          	duration: 10,
          	content: errorMsg
          });
          return;
        }
        this.closeExcelForm()
      }).catch(function (error) {
        console.error('出现错误:', error);
      });
    },
    closeExcelForm() {
      this.refreshData()
    },
    updateWordPublishSave(){
    	let updateWordNums = document.getElementsByName('updateWordNum');
    	if(!updateWordNums||updateWordNums.lenght<=0){
    		this.$message.error("请选择替换的说明文件")
            return;
    	}
    	let val = '0';
    	for(let i in updateWordNums){
    		if(updateWordNums[i].checked){
    			val = updateWordNums[i].value;
    		}
    	}
    	if(val!='1'&&val!='2'){
    		this.$message.error("请选择替换的说明文件")
            return;
    	}
    	let newPublish = this.form.updateWordPublish;
    	if(val=='1'){
    		newPublish.wordFile = this.form.updateWordFile;
    	}else if(val=='2'){
    		newPublish.wordFile2 = this.form.updateWordFile;
    	}
    	this.updateWordSave(newPublish);
    	this.closeWordFileForm();
    },
    closeWordFileForm(){
    	this.form.updateWordPublish = {};
    	this.form.updateWordFile = null;
    	this.show.wordFileModal = false;
    },
    submitPublishForm() {
      this.$refs.publishForm.validate((e) => {
        if (!e) {
          return
        }
        if (this.form.publish.dataType < 4 || this.form.publish.dataType==6) {
          if (!this.form.publish.wordFile) {
          	if (this.form.publish.dataType ==2 || this.form.publish.dataType==3) {
            	this.$message.error("请上传说明文件一")
            }else{
            	this.$message.error("请上传说明文件");
            }
            return;
          }
         
        }
		if (!this.form.publish.excelFile) {
            this.$message.error("请上传公示文件")
			return;
		}
        this.startLoadPage()
        let fileList = []
        this.options.checkBoxList.forEach((checked, index) => {
          if (!!checked) {
            fileList.push(this.options.fileList[index])
          }
        })
        this.form.publish.excelFileList = fileList
        this.form.publish.publishTime = this.form.publish.publishTime.format('yyyy-MM-DD')
        this.startLoadPage();
        this.$http.post(api.savePublish, this.form.publish).then(result => {
          if (result.status !== 200) {
			this.endLoadPage();
            this.$message.error(result.message);
            return;
          }
          this.closePublishForm()
          this.endLoadPage();
          window.location.reload()
        }).catch(function (error) {
          console.error('出现错误:', error);
          this.endLoadPage();
        });
      })
    },
    editPublish(e) {
      this.options.isEdit = true
      this.form.publish = e
      this.show.addPublish = true
    },
    submitSearch() {
      this.$http.post(`${SysApis.searchUser}`, this.searchText).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        if (result.data !== null) {
          this.dataSource = result.data.sort((a, b) => {
            return b.id - a.id
          });
        }
      }).catch(function (error) {
      });
    },
    changeTab(e) {
    	this.tables.columns = this.options.columns.publish
        if (this.tables.search.dataType >= 4 && this.tables.search.dataType < 6) {
          this.tables.columns = this.options.columns.publishZsq
        }
      this.tables.search.dataType = e
      this.form.publish.dataType = e;
      this.tables.dataSource.publish = []
      if(e<4||e==6){
		this.tables.columns[1].title = `${this.options.types[e].label}公示文件`
      }else if(e>=4&&e<6){
		this.tables.columns[0].title = `${this.options.types[e].label}公示文件`
      }
      this.getList()
    },
    resetPublishForm() {
      this.form.publish = {
        dataType: '',
        name: '',
        year: '',
        wordFile: '',
        excelFile: '',
        wordFileName: '',
        excelFileName: '',
        excelFileList: [],
        publishTime: '',
      }
      this.show.fileList = false
      // this.show.fileListButton = false
      // this.show.fileListModal = false
      // this.show.viewExcel = false
      this.form.wordList = []
      this.form.excelList = []
      this.form.wordList2 = []
    },
    refreshData() {
      this.options.fileList = []
      this.options.checkBoxList = []
      this.options.isEditList = []
      this.show.fileListModal = false
      this.show.addPublish = false
      this.show.fileList = false
      this.resetPublishForm()
      this.getList()
    },
    removePublish(e) {
      this.$http.post(`${api.delPublish}/${e.id}`).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        this.refreshData()
        this.$message.success(result.message)
      }).catch(function (error) {
      });
    },
    closePublishForm() {
      this.show.addPublish = false
      this.refreshData()
    },
  }
}
</script>

<style lang="less" scoped>
.excel-parent {
  width: 100%;
  height: 500px;
}

.table-title {
  padding: 10px;
}

.drawer-bottom-button {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.file-list {
  height: 30vh;
  overflow: auto;
}

/*滚动条整体样式*/
.file-list::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.file-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.file-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
</style>
